import { useParams } from "react-router-dom"
import Form from "./form";
import usePrivateCompanyLead from "@/features/privateCompanyLeadsFunnel/hooks/usePrivateCompanyLead";

const Update = () => {
  const { privateCompanyLeadId } = useParams();
  const { data: privateCompanyLead, isPending: isLoadingPrivateCompanyLead } = usePrivateCompanyLead(privateCompanyLeadId || '');

  return (
    <>
      {(!isLoadingPrivateCompanyLead && privateCompanyLead) && (
        <Form privateCompanyLead={privateCompanyLead} />
      )}
    </>
  )
}

export default Update